/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import BarChart from "components/barChart";
import DonutChart from "components/donutChart";
import React, { useState } from "react";

export default function StateChart({
  data,
  filters,
  disabledNavigation,
}: {
  data: any;
  filters: any;
  disabledNavigation?: boolean;
}) {
  const [chartType, setChartType] = useState<ApexChart["type"]>("bar");

  return (
    <div>
      <div className="grid justify-between grid-cols-[1fr_160px] items-center">
        <h4 className="font-semibold text-lg">
          Open Cases By Assignment Group
        </h4>
        <Select
          onValueChange={(e) => {
            setChartType(e as ApexChart["type"]);
          }}
          value={chartType}
        >
          <SelectTrigger className="my-3">
            <SelectValue placeholder="Select Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="donut">Donut Chart</SelectItem>
            <SelectItem value="bar">Bar Chart</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {chartType === "donut" && (
        <DonutChart
          data={data || []}
          disabledNavigation={disabledNavigation}
          label="assignmentGroup"
          series="count"
          dataKey="assignmentGroup"
          queryString={`&status=opentotal${filters?.account ? `&accountId=${filters.account.id}` : ""}${filters?.region ? `&region=${filters.region.id}` : ""}${filters?.date ? `&period=${filters.date.id}` : ""}`}
        />
      )}
      {chartType === "bar" && (
        <BarChart
          data={data || []}
          disabledNavigation={disabledNavigation}
          label="assignmentGroup"
          series="count"
          dataKey="assignmentGroup"
          queryString={`&status=opentotal${filters?.account ? `&accountId=${filters.account.id}` : ""}${filters?.region ? `&region=${filters.region.id}` : ""}${filters?.date ? `&period=${filters.date.id}` : ""}`}
        />
      )}
    </div>
  );
}
